import { formatCurrency } from "../utils/SaitUtils";

/*
	Obbligatori:
		headerName
		field
	Facoltativi:
		width
*/

export default function SaitCurrencyColumn(config) {
	return {
		headerName: config.headerName,
		width: config.width,
		field: config.field,
		hidden: config.hidden || false,
		flex: config.flex,
		columnType: "currency",
		type: "number",
		renderCell: config.renderCell,
		valueGetter: config.valueGetter,
		valueFormatter: (value, row, column, apiRef) => (value || value === 0 ? formatCurrency(value) : value),
		objmod: config.objmod,
	};
}
